<template>
  <div class="checkSku">
    <el-dialog
      width="600px"
      title="选择班级"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body>
        <div>
          班级名称 <el-input size="small" v-model="filter.skuName" placeholder="请输入" style="width: 200px"></el-input>
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </div>
        <el-table :data="list" border style="margin-top: 10px">
          <el-table-column align="center" label="班级ID" prop="id" width="170"></el-table-column>
          <el-table-column align="center" label="班级名称" prop="skuName"></el-table-column>
          <el-table-column align="center" label="操作" prop="" width="80">
            <template slot-scope="scope">
              <a href="javascript:;" @click="check(scope.row)">选择</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
    </el-dialog>
  </div>
</template>

<script>
import { getPageList } from '@/api/product/classManage'
export default {
  name: 'CheckSku',
  data () {
    return {
      innerVisible: false,
      filter: {
        page: 1,
        limit: 10,
        courseType: 2,
        skuName: ''
      },
      list: [],
      total: 0
    }
  },
  methods: {
    init() {
      this.innerVisible = true
      this.getList()
    },
    async getList() {
      const res = await getPageList(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    check(row) {
      this.$emit('check', row)
      this.reset()
      this.innerVisible = false
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = null
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.filter.courseType = 2
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.checkSku {

}
</style>
